export default __webpack_public_path__ + "static/media/H1015.7d735929.mp3";